<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.motorMonitoringDevice.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.motorMonitoringDevice.add')}}</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.motorMonitoringDevice.delete')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.motorMonitoringDevice.codePh')"></el-input>
                <el-input v-model="query.Field2" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.motorMonitoringDevice.namePh')"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.motorMonitoringDevice.search')}}</el-button>
            </div>
        </div>

        <el-table :data="motors" border class="table" ref="multipleTable" :element-loading-text="$t('pages.motorMonitoringDevice.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected" :height="tableHeight">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" width="50" :label="$t('pages.motorMonitoringDevice.index')"></el-table-column>
            <el-table-column sortable prop="name" :label="$t('pages.motorMonitoringDevice.name')"></el-table-column>
            <el-table-column prop="code" :label="$t('pages.motorMonitoringDevice.deviceCode')"></el-table-column>
            <el-table-column prop="comPort" :label="$t('pages.motorMonitoringDevice.port')"></el-table-column>
            <el-table-column prop="rate" :label="$t('pages.motorMonitoringDevice.baudRate')"></el-table-column>
            <el-table-column :label="$t('pages.motorMonitoringDevice.enabled')">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isUseFt" @change="changeUse(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="agreementType" :label="$t('pages.motorMonitoringDevice.agreementType')">
                <template slot-scope="scope">{{ scope.row.agreementType | agreementTypeFormat }}</template>
            </el-table-column>
            <el-table-column sortable prop="modifyDate" :label="$t('pages.motorMonitoringDevice.modifyTime')" width="140">
                <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
            </el-table-column>
            <el-table-column :label="$t('pages.motorMonitoringDevice.operation')" width="110" align="center">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.motorMonitoringDevice.edit')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" :close-on-click-modal="false" @close="clsOpt">
        <el-form ref="motor" :model="motor" :rules="rules" label-width="90px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('pages.motorMonitoringDevice.name')" prop="name">
                        <el-input v-model="motor.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('pages.motorMonitoringDevice.deviceCode')" prop="code">
                        <el-input v-model="motor.code"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('pages.motorMonitoringDevice.port')" prop="comPort">
                        <el-input v-model="motor.comPort"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('pages.motorMonitoringDevice.baudRate')" prop="rate">
                        <el-input-number v-model="motor.rate" class="size-full"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('pages.motorMonitoringDevice.agreementType')" prop="agreementType">
                        <el-select v-model="motor.agreementType" class="size-full">
                            <el-option v-for="item in AgreementVersion" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$t('pages.motorMonitoringDevice.use')" prop="isUse">
                        <el-switch v-model="motor.isUse"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editVisible = false">{{$t('pages.motorMonitoringDevice.cancel')}}</el-button>
            <el-button type="primary" @click="saveEdit('motor')">{{$t('pages.motorMonitoringDevice.confirm')}}</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    SortField
} from '../../utils/helper';
import {
    MotorParaSet
} from '../../api/MotorMonitoringDevice';
import {
    provinceAndCityData,
    CodeToText
} from 'element-china-area-data';
let that;
export default {
    name: 'motor',
    data: function () {
        return {
            tableHeight: window.innerHeight * 0.6,
            headTitle: '',
            viewVisible: false,
            isadd: false,
            motor: {},
            paramSet: {},
            editVisible: false,
            paramVisible: false,
            motors: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            query: {
                Field1: '',
                Field2: '',
                PageIndex: 1,
                PageSize: 15
            },
            volidArr: [],
            FrequencyArr: [],
            rules: {
                code: [{
                        required: true,
                        message: this.$t('pages.motorMonitoringDevice.valid.codeRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 1,
                        max: 15,
                        message: this.$t('pages.motorMonitoringDevice.valid.codeLength'),
                        trigger: 'blur'
                    }
                ],
                name: [{
                    required: true,
                        message: this.$t('pages.motorMonitoringDevice.valid.nameRequired'),
                    trigger: 'blur'
                }],
                mineName: [{
                    required: true,
                        message: this.$t('pages.motorMonitoringDevice.valid.mineNameRequired'),
                    trigger: 'blur'
                }],
                frequencyId: [{
                    required: true,
                        message: this.$t('pages.motorMonitoringDevice.valid.planRequired'),
                    trigger: 'blur'
                }]
            },
            equimentType: [],
            pRules: {
                zerov: [{
                    required: true,
                        message: this.$t('pages.motorMonitoringDevice.valid.zeroRequired'),
                    trigger: 'blur'
                }],
                kv1: [{
                    required: true,
                        message: this.$t('pages.motorMonitoringDevice.valid.kvRequired'),
                    trigger: 'blur'
                }],
                speedcompyv: [{
                    required: true,
                        message: this.$t('pages.motorMonitoringDevice.valid.speedCoeffRequired'),
                    trigger: 'blur'
                }]
            },
            options: provinceAndCityData,
            selectedOptions: []
        };
    },
    filters: {
        motortypeFormat(UserType) {
            var usertypeName = '';
            var list = that.equimentType.filter((x) => x.value == UserType);
            if (list.length > 0) {
                usertypeName = list[0].name;
            }
            return usertypeName;
        },
        agreementTypeFormat(UserType) {
            var usertypeName = '';
            var list = that.AgreementVersion.filter((x) => x.id == UserType);
            if (list.length > 0) {
                usertypeName = list[0].name;
            }
            return usertypeName;
        }
    },
    async created() {
        var res = await this.$zybhttp.get('Motor/GetAgreementVersion', {});
        if (res.data.status == 0) {
            this.AgreementVersion = res.data.data;
        }
        var search = {
            Field2: 'equimentType',
            Field4: '1'
        };
        var resequ = await this.$zybhttp.post('DataCode/GetStructList', search);
        if (resequ.data.status == 0) {
            this.equimentType = resequ.data.data.list;
        }
    },
    beforeCreate() {
        that = this;
    },
    mounted() {
        this.getData();
    },
    methods: {
        saveEdit() {
            this.$refs['motor'].validate((valid) => {
                if (valid) {
                    this.motor.isUse = this.motor.isUse ? '1' : '0';
                    var loc = [];
                    for (let i = 0; i < this.selectedOptions.length; i++) {
                        loc.push(CodeToText[this.selectedOptions[i]]);
                    }
                    this.motor.provincecityCode = this.selectedOptions.join('/');
                    this.motor.provinceCity = loc.join('/');
                    console.log(this.motor);
                    if (this.isadd) {
                        this.$zybhttp
                            .post('Motor/MotorAdd', this.motor)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(res.data.msg);
                                    this.getData();
                                    this.editVisible = false;
                                    this.motor = {};
                                } else {
                                    this.$notify.error(res.data.msg);
                                }
                })
                .catch((err) => this.$notify.error(this.$t('pages.motorMonitoringDevice.addError')));
                    } else {
                        this.$zybhttp
                            .post('Motor/MotorUpdate', this.motor)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(res.data.msg);
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(res.data.msg);
                                }
                            })
                            .catch((err) => this.$notify.error('网络异常！修改失败'));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        saveParam() {
            this.$refs['paramSet'].validate((valid) => {
                if (valid) {
                    console.log(this.paramSet);
                    this.$zybhttp
                        .post('Motor/MotorParaSet', this.paramSet)
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(res.data.msg);
                                this.getData();
                                this.paramVisible = false;
                                this.paramSet = {};
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch((err) => this.$notify.error('网络异常！添加失败'));
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        clsOpt() {
            this.getData();
        },

        getData() {
            this.$zybhttp
                .post('Motor/GetList', this.query)
                .then((res) => {
                    console.log(res.data.status);
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            console.log(x);
                            x.isUseFt = x.isUse == '1';
                            x.isUseMonitor = x.isShowMonitor == '1';
                            return x;
                        }, []);
                        this.motors = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.motorMonitoringDevice.fetchError')));
        },
        getFrequency() {
            var serach = {};
            this.$zybhttp
                .post('Frequency/GetList', serach)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.FrequencyArr = d.sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.motorMonitoringDevice.fetchError')));
        },
        getAxiso() {
            this.$zybhttp
                .get('Motor/MotorDel?ids=1')
                .then((res) => {})
                .catch((err) => console.log(err, '网络异常！获取列表失败！'));
        },
        handleEdit(id, row) {
            this.getFrequency();
            this.motor = JSON.parse(JSON.stringify(row)); // row;
            this.motor.id = id;
            this.editVisible = true;
            this.motor.isUse = this.motor.isUse == 1;
            this.selectedOptions = this.motor.provinceCityCode == null ? [] : this.motor.provinceCityCode.split('/');
            this.isadd = false;
            this.headTitle = '修改设备信息';
        },
        dbSelected(row) {
            this.getFrequency();
            this.motor = row;
            this.motor.id = row.id;
            this.editVisible = true;
            this.motor.isUse = this.motor.isUse == 1;
            this.selectedOptions = this.motor.provinceCityCode == null ? [] : this.motor.provinceCityCode.split('/');
            this.isadd = false;
            this.headTitle = '修改设备信息';
        },
        handleShow(index, row) {
            this.motor = row;
            this.viewVisible = true;
        },
        handleAdd() {
            this.getFrequency();
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.motor = {};
            this.isadd = true;
            let date = new Date();
            this.motor.createUserId = userinfo.loginId;
            this.motor.modifyUserId = userinfo.loginId;
            this.motor.rate = 9600;
            this.motor.parity = 0;
            this.motor.dataBits = 8;
            this.motor.stopBits = 1;
            this.motor.isUse = true;
            this.editVisible = true;
            this.selectedOptions = [];
            this.headTitle = '新增设备信息';
        },
        handleChange() {
            var loc = '';
            for (let i = 0; i < this.selectedOptions.length; i++) {
                loc += CodeToText[this.selectedOptions[i]];
            }
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.motorMonitoringDevice.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.motorMonitoringDevice.confirmDelete'), this.$t('pages.motorMonitoringDevice.tip'), {
                    type: 'warning'
                })
                .then(() => {
                    this.$zybhttp
                        .get('Motor/MotorDel', {
                            params: {
                                ids: strValue
                            }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(`删除了${str}`);
                                this.getData();
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.motorMonitoringDevice.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        async paramSetFun() {
            const length = this.multipleSelection.length;
            let data = {};

            if (length == 0) {
                this.$notify.warning(this.$t('pages.motorMonitoringDevice.warn.selectParamRow'));
                return;
            }
            if (length > 1) {
                this.$notify.warning(this.$t('pages.motorMonitoringDevice.warn.onlyOneRow'));
                return;
            }
            data = this.multipleSelection[0];
            if (data.isUse != '1') {
                this.$notify.warning(this.$t('pages.motorMonitoringDevice.warn.onlyEnabled'));
                return;
            }
            var res = await MotorParaSet(data.id);
            if (res.status != 0) {
                this.$notify.warning(res.msg);
                return;
            } else {
                this.paramVisible = true;
                var pdata = res.data;
                this.paramSet = pdata;
            }
        },
        indexMethod(index) {
            return index + 1;
        },
        changeUse(row) {
            row.isUse = row.isUseFt ? '1' : '0';
            var motorType = row.motorType;
            if (motorType == '2' && this.volidArr.indexOf(row.id + '') > -1) {
                this.$notify.warning('该给料机在秤组中已启用，不允许停用！');
                this.getData();
                return;
            }
            this.$zybhttp
                .post('Motor/MotorUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(res.data.msg);
                        this.getData();
                    } else {
                        console.log(res.data.msg);
                        this.$notify.error(res.data.msg);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.motorMonitoringDevice.updateError')));
        },
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
